import * as React from 'react';
import { BrowserRouter as Router, Route, Link, Redirect } from 'react-router-dom';
import { LoginPage } from './pages/login/login';
import { HomePage } from './pages/home/home';
import { Cookies, withCookies } from 'react-cookie';
import { AppContainer } from './app.styles';
import { MaintenancePage } from './pages/maintenance/maintenance';
import { TicketPage } from './pages/ticket/ticket';
import { NewTicketPage } from './pages/newTicket/newTicket';
import { SubmitConfirmationPage } from './pages/submitConfirmation/submitConfirmation';

interface State {
  token: string;
}

interface Props {
  cookies?: Cookies;
}

class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      token: localStorage.getItem('token')
    };
  }

  public render() {
    const token = this.state.token;

    return (
      <AppContainer>
        <Router>
          <Route exact path='/' render={() => token ? <HomePage /> : <Redirect to='/login'/>}/>
          <Route path='/login' render={() => <LoginPage cookies={this.props.cookies} />} />
          <Route path='/maintenance' render={() => <MaintenancePage/>} />
          <Route path='/ticket/:number' render={(data: any) => {
            return <TicketPage number={data.match.params.number} userId={'veranda'}/>;
          }} />
          <Route path='/new_ticket' render={() => <NewTicketPage />} />
          <Route path='/submit_confirmation' render={() => <SubmitConfirmationPage />} />
        </Router>
      </AppContainer>
    );
  }
}

export default withCookies(App);
